import { useEffect } from 'react'


const useChangeBodyStyles = (styles = []) => {
  useEffect(() => {
    styles.forEach((style) => {
      document.body.classList.add(style)
    })

    return () => {
      styles.forEach((style) => {
        document.body.classList.remove(style)
      })
    }
  }, [])
}


export default useChangeBodyStyles
